exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tablaAplicaciones tr th,\r\n.tablaAplicaciones tr td {\r\n    width: 150px !important;\r\n    min-width: 150px !important;\r\n    text-align: center;\r\n    vertical-align: middle;    \r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/aplicacionesTransporte/aplicaciones-transporte.style.css
// module id = ../../../../../src/app/views/empresas/aplicacionesTransporte/aplicaciones-transporte.style.css
// module chunks = 0